exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DateRangeFilterForm {\n  display: flex;\n}\n\n.DateRangeFilterForm>div {\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n}\n\n.DateRangeFilterForm>div>input {\n  margin-bottom: 10px;\n}\n", ""]);

// exports
